// extracted by mini-css-extract-plugin
export default {"cover":"styles_cover__wEOTz"};